export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11407.130d4156.jpg";